{
  "Open support, new reply": "Support openen, nieuw antwoord",
  "Open support": "Support openen",
  "Attachment": "Bijlage",
  "Fin · previous AI assistant": "Fin · vorige AI-assistent",
  "EventLive support team": "Supportteam van EventLive",
  "{name} · EventLive support": "{name} · support van EventLive",
  "EventLive AI assistant": "AI-assistent van EventLive",
  "Could not restore your previous conversation. You can retry by reopening the app.": "Je vorige gesprek kon niet worden hersteld. Open de app opnieuw om het nog eens te proberen.",
  "Please choose a smaller image.": "Kies een kleinere afbeelding.",
  "Please choose a JPEG or PNG image.": "Kies een JPEG- of PNG-afbeelding.",
  "Open {name}": "{name} openen",
  "We’re here to help": "We helpen je graag",
  "Team review requested · AI can still help": "Doorgestuurd naar het team · de AI kan nog steeds helpen",
  "Collapse chat": "Chat inklappen",
  "Expand chat": "Chat uitklappen",
  "Close support": "Support sluiten",
  "Current conversation": "Huidig gesprek",
  "Hi! Ask me anything about EventLive: pricing, planning your livestream, or watching an event.": "Hoi! Vraag me alles over EventLive: prijzen, het plannen van je livestream of het bekijken van een evenement.",
  "Have an account? Sign in for help with your events": "Heb je een account? Log in voor hulp bij je evenementen",
  "Ask anything about broadcasting, your events or pricing. I can use your account details and the screen you’re on to help.": "Vraag alles over uitzenden, je evenementen of prijzen. Om je te helpen, kan ik je accountgegevens gebruiken en zien op welk scherm je bent.",
  "Retry message": "Bericht opnieuw versturen",
  "Remove photo": "Foto verwijderen",
  "Support message": "Bericht aan support",
  "Tell us what you’re trying to do…": "Vertel ons wat je probeert te doen…",
  "Attach": "Bijvoegen",
  "Could not open your photos.": "Je foto's konden niet worden geopend.",
  "Send": "Verzenden",
  "Close support backdrop": "Support sluiten (achtergrond)",
  "AI assistant is typing": "AI-assistent is aan het typen",
  "AI assistant": "AI-assistent",
  "Please sign in to contact support.": "Log in om contact op te nemen met support.",
  "Could not reach support. Check your internet connection and try again.": "Support is niet bereikbaar. Controleer je internetverbinding en probeer het opnieuw.",
  "Support is temporarily unavailable. Please try again.": "Support is tijdelijk niet beschikbaar. Probeer het opnieuw.",
  "Could not send your message.": "Je bericht kon niet worden verzonden.",
  "No message sent": "Geen bericht verzonden",
  "Demo delivery: screenshot included · {platform}": "Demoverzending: met screenshot · {platform}",
  "Demo delivery: no screenshot · {platform}": "Demoverzending: zonder screenshot · {platform}",
  "EventLive · Widget test": "EventLive · Widgettest",
  "Synthetic account and replies. No customer data or live API calls.": "Fictief account en fictieve antwoorden. Geen klantgegevens of echte API-aanroepen.",
  "Your events": "Je evenementen",
  "Family celebration": "Familiefeest",
  "Published · Recording ready": "Gepubliceerd · Opname klaar",
  "Demo delivery status": "Status van demoverzending",
  "{brand} support team": "Supportteam van {brand}",
  "You’re chatting with the {brand} support team": "Je chat met het supportteam van {brand}",
  "You’re talking with the {brand} AI assistant": "Je praat met de AI-assistent van {brand}",
  "The {brand} team is answering here. If you step away, they’ll also reply by email.": "Het team van {brand} antwoordt hier. Ga je weg, dan krijg je het antwoord ook per e-mail.",
  "Hi! Ask me anything about YouthStream: plans and pricing, streaming your team’s games, or watching a game.": "Hoi! Vraag me alles over YouthStream: pakketten en prijzen, de wedstrijden van je team streamen of een wedstrijd bekijken.",
  "Using the app? For help with your account, open Support Chat in YouthStream’s Profile.": "Gebruik je de app? Open voor hulp bij je account de supportchat via Profiel in YouthStream."
}
